import { useEffect, useState } from 'react';
import { ClientHostType } from '@/types';
import { useStore } from '@/store';
import { getQueryStringByName } from '@/utils/helper';

// 自定义钩子
const useGetChannel = () => {
  const { channel, setChannel } = useStore();
  const type = localStorage.getItem('abc') || '3';
  const map = {
    1: ClientHostType.icirena,
    2: ClientHostType.acx,
    3: ClientHostType.galaxy,
  };
  const [user] = useState(() => {
    let channelCode = getQueryStringByName('wapid');
    if (channelCode.toLowerCase().includes('BONA'.toLowerCase())) {
      return ClientHostType.icirena;
    }
    if (channelCode.toLowerCase().includes('ACX'.toLowerCase())) {
      return ClientHostType.acx;
    }
    if (channelCode.toLowerCase().includes('GALAXY'.toLowerCase())) {
      return ClientHostType.galaxy;
    }
    return map[type];
  });
  useEffect(() => {
    console.log('[dev]看看-监听租户的变化:', user);
    console.log('navigator.userAgent=>', navigator.userAgent);
    setChannel(user);
  }, [user]);

  useEffect(() => {
    console.log('[dev]看看-监听channel的变化:', channel);
  }, [channel]);
};

export default useGetChannel;
